import administrativeAreas from 'Components/Account/AddressHelpers/administrative-areas';
import postCodeRegexes from 'Components/Account/AddressHelpers/post-code-regexes';
import postCodeFormatters from 'Components/Account/AddressHelpers/post-code-formatters';
import fieldNames from 'Components/Account/AddressHelpers/field-names';
import { countryCode as defaultCountryCode } from 'Helpers/Geo/data';

export const getAdministrativeAreaArray = (countryCode = defaultCountryCode) => {
  const administrativeAreaObject = administrativeAreas[countryCode] || {};

  return Object.keys(administrativeAreaObject).map(key => ({
    value: key,
    label: administrativeAreaObject[key] || key,
  })).sort((a, b) => a.label.localeCompare(b.label));
};

export const administrativeAreaArray = getAdministrativeAreaArray();

export const getPostCodeRegex = (countryCode = defaultCountryCode) => postCodeRegexes[countryCode] || /.{0,15}/;

export const postCodeRegex = getPostCodeRegex();

export const getPostCodeFormatter = (countryCode = defaultCountryCode) =>
  postCodeFormatters[countryCode] || (p => p);

export const postCodeFormatter = getPostCodeFormatter();

export const getFieldLabels = (countryCode = defaultCountryCode) => {
  const fieldLabels = fieldNames[countryCode] || fieldNames.default;

  Object.keys(fieldNames.default).forEach((key) => {
    if (!fieldLabels[key]) {
      fieldLabels[key] = fieldNames.default[key];
    }
  });

  return fieldLabels;
};

export const fieldLabels = getFieldLabels();

export default countryCode => ({
  administrativeAreaArray: getAdministrativeAreaArray(countryCode),
  postCodeRegex: getPostCodeRegex(countryCode),
  postCodeFormatter: getPostCodeFormatter(countryCode),
  fieldLabels: getFieldLabels(countryCode),
});
